import { AdUnitUnfilledRecoveryDTO } from 'features/inventory/api/types/adUnitUnfilledRecoveryDTO'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const AD_UNIT_UNFILLED_RECOVERY_FRAGMENT: TypedDocumentNode<AdUnitUnfilledRecoveryDTO> = gql`
  fragment AdUnitUnfilledRecoveryFragment on AdUnitUnfilledRecovery {
    allowMultiformatEnabled
    prebidBehaviourType
    customizePrebidBehaviour
    prebidSettingsWarnings {
      allRecoveryAdUnitDisabled
      prebidStackDisabled
      multipleBasePathUnitsDetected
      recoveryAdUnitNotAdded
    }
  }
`
